import React, { useState, useEffect } from 'react'
import { getCredeauReportData } from '../AdminActionCreator.component'
import Loader from '../../../presentationals/Loader/Loader.component'
import SavePopup from '../../../presentationals/Popup/Popup.component'
import {
    BarChart3,
    RefreshCw,
    CheckCircle2,
    XCircle,
    AlertCircle,
    ShieldAlert,
    TrendingUp,
    Cpu,
    Activity,
    Check,
    X,
    Shield,
    DollarSign,
    Clock,
    Sparkles,
    Layers,
    Zap,
    CreditCard,
    FileText,
    ChevronRight,
    Award
} from 'lucide-react'

export default function CredeauReport({ admin, allDetail }) {
    const [loading, setLoading] = useState(false);
    const [reportData, setReportData] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [popupMsg, setPopupMsg] = useState('');

    const fetchReportData = (regenerateVal = 0) => {
       
        const userId = allDetail?.userId || '';
        const loanId = allDetail?.loanId || '';
        // const userId = "WhZQV2YTRdA9lMLb0nG2WMkyS0iUPufB" || '';
        // const loanId = 'WhZQV2YTRdA9lMLb0nG2WMkyS0iUPufB    ' || '';
        const empId = admin?.emailId || '';

        setLoading(true);
        getCredeauReportData(userId, loanId, regenerateVal, empId, (res) => {
            setLoading(false);
            if (res && res.status === 200 && res.data) {
                setReportData(res.data);
                setShowPopup(false);
                setPopupMsg('');
            } else {
                setReportData(null);
                const msg = (res && res.message) ? res.message : "No Credeau report data found.";
                setPopupMsg(msg);
                setShowPopup(true);
                setTimeout(() => { setShowPopup(false); }, 5000);
            }
        });
    };

    useEffect(() => {
        fetchReportData(0);
    }, [allDetail?.userId, allDetail?.loanId]);

    const handleRegenerate = () => {
        fetchReportData(1);
    };

    const formatKey = (key) => {
        if (!key) return '';
        return key
            .replace(/_lt_/g, ' < ')
            .replace(/_gt_/g, ' > ')
            .replace(/_eq_/g, ' = ')
            .replace(/_gte_/g, ' >= ')
            .replace(/_lte_/g, ' <= ')
            .replace(/_/g, ' ')
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };

    const formatValue = (val) => {
        if (val === null || val === undefined || val === '') return 'N/A';
        if (typeof val === 'boolean') return val ? 'True' : 'False';
        if (typeof val === 'number') {
            return Number.isInteger(val) ? val.toLocaleString() : val.toFixed(4);
        }
        return val.toString();
    };

    const outputData = reportData?.output_data || {};
    const rulesOutput = outputData?.rules_output || {};
    const features = outputData?.features || {};
    const ecm = outputData?.ecm || {};

    const excludedKeys = [
        'request_id',
        'user_id',
        'reference_id',
        'workflow_version_path',
        'workflow_version',
        'engine_history',
        'app_user_id',
        'version'
    ];

    const decisionColorMap = {
        Reject: { bg: '#fff1f2', text: '#e11d48', border: '#fecdd3', badgeBg: '#ffe4e6', accent: '#f43f5e', icon: XCircle },
        Approve: { bg: '#f0fdf4', text: '#16a34a', border: '#bbf7d0', badgeBg: '#dcfce7', accent: '#22c55e', icon: CheckCircle2 },
        Proceed: { bg: '#eff6ff', text: '#2563eb', border: '#bfdbfe', badgeBg: '#dbeafe', accent: '#3b82f6', icon: Zap },
        default: { bg: '#fffbeb', text: '#d97706', border: '#fef08a', badgeBg: '#fef3c7', accent: '#f59e0b', icon: AlertCircle }
    };

    const getDecisionStyle = (decision) => decisionColorMap[decision] || decisionColorMap.default;

    const getMetricTheme = (key, val) => {
        const k = key.toLowerCase();
        if (k.includes('overdue') || k.includes('reject')) {
            return { bg: '#fff1f2', text: '#e11d48', border: '#ffe4e6', icon: ShieldAlert, iconColor: '#f43f5e' };
        }
        if (k.includes('income') || k.includes('affordability') || k.includes('amount')) {
            return { bg: '#f0fdf4', text: '#15803d', border: '#dcfce7', icon: DollarSign, iconColor: '#22c55e' };
        }
        if (k.includes('score') || k.includes('risk') || k.includes('grade')) {
            return { bg: '#eff6ff', text: '#1d4ed8', border: '#dbeafe', icon: Award, iconColor: '#3b82f6' };
        }
        return { bg: '#f8fafc', text: '#334155', border: '#e2e8f0', icon: Activity, iconColor: '#64748b' };
    };

    const finalDecision = rulesOutput.final_decision;
    const finalStyle = getDecisionStyle(finalDecision?.Decision);
    const DecisionIcon = finalStyle.icon;

    return (
        <div style={{
            padding: '100px 24px 32px 24px',
            background: 'linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%)',
            minHeight: '600px',
            borderRadius: '16px',
            marginTop: '15px',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            color: '#0f172a'
        }}>
            {showPopup && (
                <SavePopup
                    closePopup={() => setShowPopup(false)}
                    popupStatus={popupMsg}
                />
            )}

            {/* Header Section */}
            <div style={{
                background: '#ffffff',
                border: '1px solid #e2e8f0',
                borderRadius: '16px',
                padding: '20px 24px',
                marginBottom: '24px',
                boxShadow: '0 4px 20px -2px rgba(15, 23, 42, 0.04)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '16px'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                    <div style={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '12px',
                        background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#ffffff',
                        boxShadow: '0 6px 16px rgba(37, 99, 235, 0.25)'
                    }}>
                        <BarChart3 size={24} style={{ width: "auto", margin: "0" }} />
                    </div>
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <h3 style={{ margin: 0, color: '#0f172a', fontWeight: '800', fontSize: '20px', letterSpacing: '-0.3px' }}>
                                Credeau Bureau Analytics
                            </h3>
                            {outputData.is_sandbox_request && (
                                <span style={{
                                    background: '#fef3c7',
                                    color: '#b45309',
                                    fontSize: '11px',
                                    fontWeight: '700',
                                    padding: '3px 8px',
                                    borderRadius: '6px',
                                    border: '1px solid #fde68a',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '4px'
                                }}>
                                    <Sparkles size={12} style={{ width: "auto", margin: "0" }} /> SANDBOX
                                </span>
                            )}
                        </div>
                        <p style={{ margin: '4px 0 0 0', color: '#64748b', fontSize: '13px', fontWeight: '500' }}>
                            Real-time Bureau BRE Assessment & Features Engine
                        </p>
                    </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <button
                        onClick={handleRegenerate}
                        disabled={loading}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '10px 20px',
                            fontWeight: '700',
                            fontSize: '13px',
                            color: '#ffffff',
                            background: loading ? '#94a3b8' : 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
                            border: 'none',
                            borderRadius: '10px',
                            cursor: loading ? 'not-allowed' : 'pointer',
                            boxShadow: loading ? 'none' : '0 4px 14px rgba(37, 99, 235, 0.3)',
                            transition: 'all 0.2s ease',
                        }}
                    >
                        <RefreshCw size={15} style={{ width: "auto", margin: "0", animation: loading ? 'spin 1s linear infinite' : 'none' }} />
                        {loading ? 'Evaluating BRE...' : 'Regenerate Report'}
                    </button>
                </div>
            </div>

            {loading ? (
                <div style={{
                    background: '#ffffff',
                    borderRadius: '16px',
                    padding: '60px 20px',
                    textAlign: 'center',
                    border: '1px solid #e2e8f0',
                    boxShadow: '0 4px 20px -2px rgba(15, 23, 42, 0.04)'
                }}>
                    <Loader />
                    <p style={{ marginTop: '16px', color: '#64748b', fontWeight: '600', fontSize: '14px' }}>
                        Evaluating Credeau BRE rules & featurisation...
                    </p>
                </div>
            ) : !reportData ? (
                <div style={{
                    textAlign: 'center',
                    padding: '60px 24px',
                    background: '#ffffff',
                    borderRadius: '16px',
                    border: '2px dashed #cbd5e1',
                    boxShadow: '0 4px 20px -2px rgba(15, 23, 42, 0.02)'
                }}>
                    <div style={{
                        width: '56px',
                        height: '56px',
                        borderRadius: '50%',
                        background: '#eff6ff',
                        color: '#2563eb',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 16px auto'
                    }}>
                        <FileText size={28} style={{ width: "auto", margin: "0" }} />
                    </div>
                    <h4 style={{ margin: '0 0 6px 0', color: '#0f172a', fontWeight: '700' }}>No Credeau Report Available</h4>
                    <p style={{ color: '#64748b', fontSize: '13px', maxWidth: '400px', margin: '0 auto 20px auto' }}>
                        The BRE rules evaluation report has not been generated for this application yet.
                    </p>
                    <button
                        onClick={handleRegenerate}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '10px 24px',
                            fontWeight: '700',
                            fontSize: '13px',
                            color: '#2563eb',
                            background: '#eff6ff',
                            border: '1px solid #bfdbfe',
                            borderRadius: '10px',
                            cursor: 'pointer'
                        }}
                    >
                        <Zap size={16} style={{ width: "auto", margin: "0" }} /> Generate Bureau Report
                    </button>
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>

                    {/* HERO CARD: Final Decision Banner */}
                    {finalDecision && (
                        <div style={{
                            background: finalStyle.bg,
                            border: `1px solid ${finalStyle.border}`,
                            borderRadius: '16px',
                            padding: '24px 28px',
                            position: 'relative',
                            overflow: 'hidden',
                            boxShadow: '0 8px 24px -6px rgba(0,0,0,0.04)'
                        }}>
                            <div style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '6px',
                                height: '100%',
                                background: finalStyle.accent
                            }} />

                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                gap: '20px'
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                    <div style={{
                                        width: '52px',
                                        height: '52px',
                                        borderRadius: '14px',
                                        background: '#ffffff',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: finalStyle.text,
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.06)'
                                    }}>
                                        <DecisionIcon size={28} style={{ width: "auto", margin: "0" }} />
                                    </div>
                                    <div>
                                        <div style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            padding: '4px 10px',
                                            borderRadius: '20px',
                                            background: finalStyle.badgeBg,
                                            color: finalStyle.text,
                                            fontSize: '11px',
                                            fontWeight: '800',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.6px',
                                            marginBottom: '4px'
                                        }}>
                                            Final BRE Outcome
                                        </div>
                                        <h1 style={{
                                            margin: 0,
                                            color: finalStyle.text,
                                            fontWeight: '900',
                                            fontSize: '32px',
                                            letterSpacing: '-0.5px',
                                            lineHeight: 1.1
                                        }}>
                                            {finalDecision.Decision || 'N/A'}
                                        </h1>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
                                    {finalDecision.DecisionReason && (
                                        <div style={{
                                            background: '#ffffff',
                                            padding: '12px 20px',
                                            borderRadius: '12px',
                                            border: '1px solid rgba(0,0,0,0.08)',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.02)'
                                        }}>
                                            <span style={{ fontSize: '11px', color: '#64748b', display: 'block', fontWeight: '600', textTransform: 'uppercase' }}>
                                                Decision Trigger
                                            </span>
                                            <strong style={{ color: '#0f172a', fontSize: '15px', fontWeight: '700' }}>
                                                {formatKey(finalDecision.DecisionReason)}
                                            </strong>
                                        </div>
                                    )}

                                    {finalDecision.LoanAmount !== null && finalDecision.LoanAmount !== undefined && (
                                        <div style={{
                                            background: '#ffffff',
                                            padding: '12px 20px',
                                            borderRadius: '12px',
                                            border: '1px solid #86efac',
                                            boxShadow: '0 2px 8px rgba(34, 197, 94, 0.1)'
                                        }}>
                                            <span style={{ fontSize: '11px', color: '#166534', display: 'block', fontWeight: '600', textTransform: 'uppercase' }}>
                                                Approved Amount
                                            </span>
                                            <strong style={{ color: '#15803d', fontSize: '20px', fontWeight: '800' }}>
                                                ₹{Number(finalDecision.LoanAmount || 0).toLocaleString()}
                                            </strong>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* SECTION 1: Rule Engine Decisions */}
                    {Object.keys(rulesOutput).length > 0 && (
                        <div style={{
                            background: '#ffffff',
                            border: '1px solid #e2e8f0',
                            borderRadius: '16px',
                            padding: '24px',
                            boxShadow: '0 4px 20px -2px rgba(15, 23, 42, 0.04)'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                                <div style={{ background: '#f1f5f9', padding: '10px', borderRadius: '12px', color: '#2563eb' }}>
                                    <Cpu size={20} style={{ width: "auto", margin: "0" }} />
                                </div>
                                <div>
                                    <h4 style={{ margin: 0, color: '#0f172a', fontWeight: '800', fontSize: '16px' }}>
                                        Rule Engine Decision Trees
                                    </h4>
                                    <span style={{ fontSize: '12px', color: '#64748b' }}>Detailed BRE evaluation matrix & rule criteria</span>
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '18px' }}>
                                {Object.entries(rulesOutput).map(([engineKey, engineData]) => {
                                    if (!engineData || typeof engineData !== 'object') return null;
                                    const rulesEval = engineData.RulesEvaluation || {};
                                    const style = getDecisionStyle(engineData.Decision);
                                    const EngineIcon = style.icon;

                                    return (
                                        <div key={engineKey} style={{
                                            background: '#f8fafc',
                                            border: '1px solid #e2e8f0',
                                            borderRadius: '14px',
                                            padding: '18px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'space-between'
                                        }}>
                                            <div>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <span style={{ fontWeight: '800', color: '#0f172a', fontSize: '15px', textTransform: 'capitalize' }}>
                                                            {formatKey(engineKey)} Engine
                                                        </span>
                                                    </div>
                                                    <span style={{
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        gap: '4px',
                                                        padding: '4px 12px',
                                                        borderRadius: '20px',
                                                        fontSize: '11px',
                                                        fontWeight: '800',
                                                        background: style.badgeBg,
                                                        color: style.text,
                                                        textTransform: 'uppercase',
                                                        letterSpacing: '0.4px'
                                                    }}>
                                                        <EngineIcon size={12} style={{ width: "auto", margin: "0" }} />
                                                        {
                                                            engineData?.Decision?.includes("_")
                                                                ? engineData?.Decision?.replace(/_/g, " ")
                                                                : engineData?.Decision || "N/A"
                                                        }
                                                    </span>
                                                </div>

                                                {engineData.DecisionReason && (
                                                    <div style={{
                                                        background: '#ffffff',
                                                        padding: '8px 12px',
                                                        borderRadius: '8px',
                                                        border: '1px solid #e2e8f0',
                                                        marginBottom: '14px',
                                                        fontSize: '12px'
                                                    }}>
                                                        <span style={{ color: '#64748b', fontWeight: '500' }}>Reason: </span>
                                                        <strong style={{ color: '#0f172a', fontWeight: '700' }}>{formatKey(engineData.DecisionReason)}</strong>
                                                    </div>
                                                )}

                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                                    {Object.entries(rulesEval).map(([ruleName, ruleResult]) => (
                                                        <div key={ruleName} style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            fontSize: '12px',
                                                            padding: '8px 12px',
                                                            background: '#ffffff',
                                                            borderRadius: '8px',
                                                            border: '1px solid #f1f5f9'
                                                        }}>
                                                            <span style={{ color: '#334155', fontWeight: '500' }}>{formatKey(ruleName)}</span>
                                                            <span style={{
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                gap: '4px',
                                                                padding: '3px 10px',
                                                                borderRadius: '12px',
                                                                fontSize: '11px',
                                                                fontWeight: '800',
                                                                background: ruleResult ? '#dcfce7' : '#f1f5f9',
                                                                color: ruleResult ? '#15803d' : '#64748b'
                                                            }}>
                                                                {ruleResult ? <Check size={12} style={{ width: "auto", margin: "0" }} /> : <X size={12} style={{ width: "auto", margin: "0" }} />}
                                                                {ruleResult ? 'PASSED' : 'FALSE'}
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {/* SECTION 2: Re-Designed Bureau & Featurisation Metrics Cards */}
                    {Object.keys(features).length > 0 && (
                        <div style={{
                            background: '#ffffff',
                            border: '1px solid #e2e8f0',
                            borderRadius: '16px',
                            padding: '24px',
                            boxShadow: '0 4px 20px -2px rgba(15, 23, 42, 0.04)'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '22px' }}>
                                <div style={{ background: '#f1f5f9', padding: '10px', borderRadius: '12px', color: '#2563eb' }}>
                                    <TrendingUp size={20} style={{ width: "auto", margin: "0" }} />
                                </div>
                                <div>
                                    <h4 style={{ margin: 0, color: '#0f172a', fontWeight: '800', fontSize: '16px' }}>
                                        Bureau & Feature Metrics
                                    </h4>
                                    <span style={{ fontSize: '12px', color: '#64748b' }}>Extracted scorecards, risk grades & affordability parameters</span>
                                </div>
                            </div>

                            {(() => {
                                const displayFeatures = features.output_features || features;
                                return Object.entries(displayFeatures).map(([subKey, subData]) => {
                                    if (!subData || typeof subData !== 'object') return null;

                                    const filteredEntries = Object.entries(subData).filter(([k]) => !excludedKeys.includes(k));
                                    if (filteredEntries.length === 0) return null;

                                    return (
                                        <div key={subKey} style={{ marginBottom: '24px' }}>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                marginBottom: '14px',
                                                borderBottom: '2px solid #f1f5f9',
                                                paddingBottom: '8px'
                                            }}>
                                                <Layers size={15} color="#2563eb" style={{ width: "auto", margin: "0" }} />
                                                <h5 style={{ margin: 0, color: '#1e293b', fontSize: '14px', textTransform: 'capitalize', fontWeight: '800' }}>
                                                    {formatKey(subKey)} Overview
                                                </h5>
                                            </div>

                                            {/* MODERN STAT TILES DESIGN */}
                                            <div style={{
                                                display: 'grid',
                                                gridTemplateColumns: 'repeat(auto-fill, minmax(230px, 1fr))',
                                                gap: '16px'
                                            }}>
                                                {filteredEntries.map(([fKey, fVal]) => {
                                                    const theme = getMetricTheme(fKey, fVal);
                                                    const IconComp = theme.icon;

                                                    return (
                                                        <div key={fKey} style={{
                                                            background: theme.bg,
                                                            border: `1px solid ${theme.border}`,
                                                            borderRadius: '14px',
                                                            padding: '16px 18px',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            justifyContent: 'space-between',
                                                            position: 'relative',
                                                            boxShadow: '0 2px 8px rgba(0,0,0,0.02)',
                                                            transition: 'transform 0.15s ease, box-shadow 0.15s ease'
                                                        }}>
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                                                                <span style={{
                                                                    fontSize: '11px',
                                                                    color: '#64748b',
                                                                    fontWeight: '700',
                                                                    textTransform: 'uppercase',
                                                                    letterSpacing: '0.4px',
                                                                    lineHeight: '1.3'
                                                                }}>
                                                                    {formatKey(fKey)}
                                                                </span>
                                                                <div style={{
                                                                    width: '28px',
                                                                    height: '28px',
                                                                    borderRadius: '8px',
                                                                    background: '#ffffff',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    color: theme.iconColor,
                                                                    boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                                                                }}>
                                                                    <IconComp size={15} style={{ width: "auto", margin: "0" }} />
                                                                </div>
                                                            </div>

                                                            <div>
                                                                <div style={{
                                                                    fontSize: '22px',
                                                                    fontWeight: '900',
                                                                    color: fVal === null || fVal === undefined ? '#94a3b8' : theme.text,
                                                                    letterSpacing: '-0.3px',
                                                                    lineHeight: '1.2'
                                                                }}>
                                                                    {formatValue(fVal)}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    );
                                });
                            })()}
                        </div>
                    )}

                    {/* SECTION 3: Service Gateway Diagnostics */}
                    {Object.keys(ecm).length > 0 && (
                        <div style={{
                            background: '#ffffff',
                            border: '1px solid #e2e8f0',
                            borderRadius: '16px',
                            padding: '24px',
                            boxShadow: '0 4px 20px -2px rgba(15, 23, 42, 0.04)'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                                <div style={{ background: '#f1f5f9', padding: '10px', borderRadius: '12px', color: '#2563eb' }}>
                                    <Activity size={20} style={{ width: "auto", margin: "0" }} />
                                </div>
                                <div>
                                    <h4 style={{ margin: 0, color: '#0f172a', fontWeight: '800', fontSize: '16px' }}>
                                        Integration & Gateway Diagnostics
                                    </h4>
                                    <span style={{ fontSize: '12px', color: '#64748b' }}>ECM service call statuses and latencies</span>
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '14px' }}>
                                {Object.entries(ecm).map(([serviceName, serviceData]) => {
                                    if (!serviceData || typeof serviceData !== 'object') return null;
                                    const isSuccess = serviceData.external_status === 'success';

                                    return (
                                        <div key={serviceName} style={{
                                            background: '#f8fafc',
                                            padding: '16px',
                                            borderRadius: '14px',
                                            border: '1px solid #e2e8f0'
                                        }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                                                <strong style={{ fontSize: '14px', color: '#0f172a', textTransform: 'capitalize', fontWeight: '800' }}>
                                                    {serviceName}
                                                </strong>
                                                <span style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    gap: '4px',
                                                    fontSize: '11px',
                                                    padding: '3px 10px',
                                                    borderRadius: '20px',
                                                    background: isSuccess ? '#dcfce7' : '#ffe4e6',
                                                    color: isSuccess ? '#15803d' : '#e11d48',
                                                    fontWeight: '800',
                                                    textTransform: 'uppercase'
                                                }}>
                                                    {isSuccess ? <CheckCircle2 size={12} style={{ width: "auto", margin: "0" }} /> : <XCircle size={12} style={{ width: "auto", margin: "0" }} />}
                                                    {serviceData.external_status || 'N/A'}
                                                </span>
                                            </div>

                                            <div style={{
                                                fontSize: '12px',
                                                color: '#475569',
                                                display: 'grid',
                                                gridTemplateColumns: '1fr 1fr',
                                                gap: '8px',
                                                background: '#ffffff',
                                                padding: '10px 12px',
                                                borderRadius: '10px',
                                                border: '1px solid #f1f5f9'
                                            }}>
                                                <div>Code: <strong style={{ color: '#0f172a' }}>{serviceData.external_response_code ?? 'N/A'}</strong></div>
                                                <div>Source: <strong style={{ color: '#0f172a' }}>{serviceData.ecm_data_source ?? 'N/A'}</strong></div>
                                                <div>Retries: <strong style={{ color: '#0f172a' }}>{serviceData.external_retries ?? 0}</strong></div>
                                                <div>Latency: <strong style={{ color: '#0f172a' }}>{serviceData.external_latency ?? 0}ms</strong></div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                </div>
            )}
        </div>
    );
}
